if (!customElements.get('wlsn-product-switcher')) {
    class WLSNProductSwitcher extends HTMLElement {
        constructor() {
            super();

            this.classes = {
                activeClass: 'active',
                hiddenClass: 'hidden',
                slideClass: 'swiper-slide',
                productCard: 'js-wlsn-product-card',
                productCardWrapper: 'js-wlsn-product-cards',
                atc: 'js-wlsn-product-switcher-btn',
                slider: 'js-wlsn-product-switcher-slider',
                stickyCTAPrice: 'js-wlsn-sticky-cta-price',
                reworkedTrigger: 'js-wlsn-product-switcher-reworked-trigger'
            };

            this.elements = {
                productCards: this.querySelectorAll(`.${this.classes.productCard}`),
                productCardWrapper: this.querySelector(`.${this.classes.productCardWrapper}`),
                atc: this.querySelector(`.${this.classes.atc}`),
                slider: this.querySelectorAll(`.${this.classes.slider}`),
                stickyCTAPrice: this.querySelector(`.${this.classes.stickyCTAPrice}`),
                reworkedTrigger: this.querySelectorAll(`.${this.classes.reworkedTrigger}`)
            };

            this.defaultSelectedIndex = parseInt(this.dataset.defaultSelected, 10) || 0;
        }

        connectedCallback() {
            if (this.elements.stickyCTAPrice) {
                this.updateStickyCTAPrice();
            }

            if (
                this.elements.productCards.length > 0 &&
                this.elements.productCards[this.defaultSelectedIndex]
            ) {
                this.updateActiveCard(this.elements.productCards[this.defaultSelectedIndex]);
            }

            this.elements.productCards.forEach((card) => {
                card.addEventListener('click', () => {
                    this.updateActiveCard(card);
                    this.updateReworkedData(card);
                });
            });
        }

        updateStickyCTAPrice() {
            let lowestPrice = Infinity;
            let formattedPrice = '';

            this.elements.productCards.forEach(card => {
                const price = parseInt(card.getAttribute('data-price-final'));
                if (price < lowestPrice) {
                    lowestPrice = price;
                    formattedPrice = card.getAttribute('data-price-final-formatted');
                }
            });

            if (formattedPrice) {
                this.elements.stickyCTAPrice.textContent = formattedPrice;
            }
        }

        updateActiveCard(card) {
            this.elements.productCards.forEach((c) =>
                c.classList.remove(this.classes.activeClass)
            );
            card.classList.add(this.classes.activeClass);

            const url = card.getAttribute('data-url');
            if (this.elements.atc) {
                this.elements.atc.href = url;
            }
            if (this.elements.slider.length > 0) {
                const cardId = card.getAttribute('data-id');
                this.elements.slider.forEach(slider => {
                    const sliderId = slider.getAttribute('data-id');
                    if (sliderId === cardId) {
                        slider.classList.remove(this.classes.hiddenClass);
                    } else {
                        slider.classList.add(this.classes.hiddenClass);
                    }
                });
            }
        }

        updateReworkedData(card) {
            if (card && !!this.elements.reworkedTrigger.length) {
                const reworkedId = card.getAttribute('data-reworked-product-id-data-update');

                // Display reworked triggers
                this.elements.reworkedTrigger.forEach(trigger => {
                    trigger.classList.remove(this.classes.activeClass);
                });
                if (reworkedId) {
                    this.elements.reworkedTrigger.forEach(trigger => {
                        if (trigger.getAttribute('data-product-switcher-reworked-product-id-trigger') === reworkedId) {
                            trigger.classList.add(this.classes.activeClass);
                        }
                    });
                }

                // Update reworked data
                const reworkedTrigger = this.querySelector(`[data-reworked-product-id-trigger="${reworkedId}"]`);
                const reworkedData = this.querySelector(`script[data-reworked-product-id-data="${reworkedId}"]`);
                if (reworkedTrigger && reworkedData) {
                    const reworkedDataJson = JSON.parse(reworkedData.textContent);
                    const isActive = reworkedTrigger.classList.contains(this.classes.activeClass);
                    this.elements.atc.href = isActive ? reworkedDataJson.reworked.checkoutLink : reworkedDataJson.regular.checkoutLink;
                }
            }
        }

    }
    customElements.define('wlsn-product-switcher', WLSNProductSwitcher);
}
